// extracted by mini-css-extract-plugin
export default {"container":"SplitProgressBar_container__J48LU","label":"SplitProgressBar_label__95+IA","progressBar":"SplitProgressBar_progressBar__5ST7R"};